import * as React from 'react';
import * as Redux from 'redux';
import { connect } from 'react-redux';
import ReactSVG from 'react-svg';
import styled from 'styled-components';
import _ from 'lodash';
import DefaultButton from './../../../components/DefaultButton';
import GhostButton from './../../../components/GhostButton';
import { faultsDictionary } from './../../../utilities/faultsDictionary';
import { renderAttributeEdit } from './../../../utilities/renderAttributes.jsx'
import { translate } from "react-i18next";
import IconClose from './../../../icons/cancel2.svg';
import {
    addFault,
    editFault,
    startDrawingFault,
    finishDrawingFault,
    cancelDrawingFault,
    clearMessage,
} from './../../../actions/faults';
import { setEditMode } from './../../../actions/map';
import messageManager from './../../../utilities/messageManager';

const SidebarCover = styled.div`
    left: 0;
    height: calc(100% - 32px);
    width: 100%;
    position: absolute;
    z-index: 1;
    background-color: #fcfcfc;
    color: #1f1f1f;
    top: 32px;
    display:flex;
    flex-direction: column;
    align-items: center;
`;

const SidebarContent = styled.div`
    display: flex;
    flex-direction: column;
    width: calc(100% - 20px);
`;
const CreatorTitle = styled.h3`
    margin: 10px 0 10px;
    color: #265a9c;
    font-size: 16px;
    font-weight: normal;
    text-align: center;
`;

const CreatorRow = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0 0 5px 5px;
    span {
        margin: 0 0 2px 0;
        font-size: 13px;
        color: #4b4b4b;
    }
    input, select{
        border: 1px solid #bfbfbf;
        color: #265a9c;
        font-weight: 600;
        font-family: "Open Sans", sans-serif;
        line-height: 16px;
    }
    input {
        padding: 2px 4px;
        width: calc(100% - 20px);
        ::placeholder{
            font-weight: 500;
        }
    }
    select {
        width: calc(100% - 10px);
        padding: 2px 4px;
    }
`;

const Tip = styled.p`
    white-space: pre-wrap;
`;

const ButtonWrapper = styled.div`
    display: flex;    
`;

const FaultTagsWrapper = styled.div`
    display: flex;
    justify-content: unset;
    flex-wrap: wrap;
`;

const FaultTag = styled.div`
    background-color: ${props => props.color};
    border-radius: 4px;    
    padding: 2px 5px 2px 5px;
    margin-right: 5px;
    margin-bottom: 5px;
    font-size: small;
    font-weight: bold;
    display: flex;
`;

const OtherFaultTag = styled.div`
    background-color: ${props => props.color};
    border-radius: 4px;    
    padding: 2px 5px 2px 5px;
    margin-right: 5px;
    margin-bottom: 5px;
    font-size: small;
    font-weight: bold;
    display: flex;
    :hover {
        box-shadow: inset 0 0 4px #000000;
    }
`;

const DeleteFaultTagButton = styled.div`
    border-radius: 5px;  
    margin-left: 5px;    
    width: 20px;
    display: flex;
    justify-content: center;
    :hover {
        box-shadow: inset 0 0 2px #000000;
    }
`;

const FaultTagsContainer = styled.div`
    display: ${props => props.visible ? 'flex' : 'none'};
    margin-right: 10px;
    border: 1px solid #bfbfbf;
    height: 80px;
    border-radius: 4px;
    flex-wrap: wrap;
    padding: 5px;
    overflow: auto;
    span {
        font-size: small;
        margin-bottom: 2px;
        width: 100%;
    }
`;

class FlightCreator extends React.Component {
    constructor(props) {
        super();
        this.state = {
            editedFault: this.getClearFeature(),
            createButtonDisabled: false,
            isDrawing: false,
            faultTagsContainerVisible: false
        }
    }

    getClearFeature() {
        const editedFault = {};
        for (const attribute in faultsDictionary) {
            switch (faultsDictionary[attribute].renderType) {
                case 'select':
                    editedFault[attribute] = '';
                    break;
                case 'tag':
                    editedFault[attribute] = [];
                    break;
                default:
                    editedFault[attribute] = '';
                    break;
            }
        }
        editedFault.id = 0;
        editedFault.faultCategory = 1;
        return editedFault;
    }

    componentDidUpdate(prevProps) {
        const { message, clearMessage, selectedFault, visible, t } = this.props;
        if (message.text !== "") {
            clearMessage();
            const translatedMessage = {
                text: t(message.text),
                type: message.type
            }
            messageManager.show(translatedMessage);
        }

        if (visible && !prevProps.visible) {
            this.setState({
                editedFault: selectedFault ? _.cloneDeep(selectedFault) : this.getClearFeature()
            })
        }

        if (prevProps.drawingFault !== this.props.drawingFault
            && (this.props.drawingFault === 'finished' || this.props.drawingFault === 'canceled')) {
            this.setState({
                isDrawing: false
            })
        }
    }

    addFaultTag(tagId) {
        const { editedFault } = this.state;
        editedFault.faultTags.push({
            faultId: editedFault.id,
            dicFaultTagId: tagId
        });
        this.setState({
            editedFault: editedFault,
            faultTagsContainerVisible: false
        });
    }

    removeFaultTag(tagId) {
        const { editedFault } = this.state;
        const index = editedFault.faultTags.findIndex(f => f.dicFaultTagId === tagId);
        if (index !== -1) editedFault.faultTags.splice(index, 1);
        this.setState({ editedFault: editedFault });
    }

    render() {
        const { visible, t, faultTagsDictionary } = this.props;
        const { createButtonDisabled, editedFault, faultTagsContainerVisible } = this.state;

        if (visible) {
            return (
                <SidebarCover>
                    <SidebarContent>
                        <CreatorTitle>
                            {editedFault.id === 0
                                ? <b>{`${t('New fault')}`}</b>
                                : <b>{`${t('Edit fault')}`}</b>
                            }
                        </CreatorTitle>
                        <CreatorRow>
                            <span>{t('Tags')}</span>
                            <FaultTagsWrapper>
                                {editedFault.faultTags.map(faultTag => {
                                    const tag = faultTagsDictionary.find(d => d.id === faultTag.dicFaultTagId);
                                    return (
                                        <FaultTag
                                            key={tag.id}
                                            color={tag.color}>
                                            {t(tag.name)}
                                            <DeleteFaultTagButton onClick={() => this.removeFaultTag(tag.id)}>
                                                <ReactSVG
                                                    path={IconClose}
                                                    style={{
                                                        fill: '#000000',
                                                        width: '10px',
                                                        height: '10px',
                                                    }}
                                                />
                                            </DeleteFaultTagButton>
                                        </FaultTag>);
                                })}
                                <GhostButton
                                    style={{
                                        fontSize: 'small',
                                        fontWeight: 'bold',
                                        marginBottom: '5px'
                                    }}
                                    visible={!faultTagsContainerVisible}
                                    onClick={() => this.setState({ faultTagsContainerVisible: !faultTagsContainerVisible })}>
                                    {t('Add tag')}
                                </GhostButton>
                            </FaultTagsWrapper>
                            <FaultTagsContainer visible={faultTagsContainerVisible}>
                                <span>
                                    {t('Click on the tag from list below to assign it to the fault')}
                                </span>
                                {faultTagsDictionary
                                    .filter(tag => {
                                        return !editedFault.faultTags.some(f => f.dicFaultTagId === tag.id);
                                    })
                                    .map(tag => {
                                        return (
                                            <OtherFaultTag
                                                key={tag.id}
                                                color={tag.color}
                                                onClick={() => this.addFaultTag(tag.id)}>
                                                {t(tag.name)}
                                            </OtherFaultTag>);
                                    })}
                            </FaultTagsContainer>
                        </CreatorRow>
                        {Object.keys(faultsDictionary)
                            .filter(attribute => {
                                return faultsDictionary[attribute].isEditable;
                            })
                            .map(attribute => {
                                const { header } = faultsDictionary[attribute];
                                return (
                                    <CreatorRow
                                        key={`${header}_fault_creator_input`}>
                                        <span>
                                            {`${t(header)}`}
                                        </span>
                                        <span>
                                            {renderAttributeEdit(editedFault.id, faultsDictionary[attribute], editedFault[attribute], (newValue) => {
                                                editedFault[attribute] = newValue;
                                                this.setState({
                                                    editedFault
                                                });
                                            }, t)}
                                        </span>
                                    </CreatorRow>
                                )
                            })}
                        <Tip>
                            {t('Click on the button then on the map to mark fault')}
                        </Tip>
                        <ButtonWrapper>
                            <GhostButton
                                style={{
                                    height: '25px',
                                    width: '130px',
                                    marginRight: '5px',
                                }}
                                visible={this.state.isDrawing}
                                title={t('Finish drawing')}
                                onClick={() => {
                                    this.props.finishDrawingFault();
                                    this.setState({ isDrawing: false })
                                }}>
                                {t('Finish drawing')}
                            </GhostButton>
                            <DefaultButton
                                style={{
                                    height: '25px',
                                    width: '130px',
                                }}
                                visible={!this.state.isDrawing}
                                title={t('Draw geometry')}
                                onClick={() => {
                                    this.props.startDrawingFault(editedFault);
                                    this.setState({ isDrawing: true })
                                }}>
                                {t('Draw geometry')}
                            </DefaultButton>
                        </ButtonWrapper>
                        <GhostButton
                            style={{
                                position: 'absolute',
                                bottom: '10px',
                                right: '85px',
                                height: '25px',
                                width: '55px',
                            }}
                            title={t('Cancel')}
                            onClick={() => {
                                this.setState({
                                    isDrawing: false
                                });
                                this.props.cancelDrawingFault();
                                this.props.closeSelf();
                                this.props.setEditMode(false);
                            }}>
                            {t('Cancel')}
                        </GhostButton>
                        <DefaultButton
                            disabled={createButtonDisabled}
                            style={{
                                position: 'absolute',
                                bottom: '10px',
                                right: '20px',
                                height: '25px',
                                width: '55px',
                            }}
                            title={t('Save')}
                            onClick={() => {
                                if (editedFault.description) {
                                    if (editedFault.id === 0)
                                        this.props.addFault(this.props.axiosInstance, editedFault);
                                    else
                                        this.props.editFault(this.props.axiosInstance, editedFault);

                                    this.setState({
                                        isDrawing: false,
                                    });
                                    this.props.finishDrawingFault();
                                    this.props.closeSelf();
                                    this.props.setEditMode(false);
                                }
                                else {
                                    messageManager.show({
                                        type: 'error',
                                        text: t('Fault description could not be empty'),
                                    })
                                }
                            }}>
                            {t('Save')}
                        </DefaultButton>
                    </SidebarContent>
                </SidebarCover >
            );
        }
        else return null;
    }
};

const mapStateToProps = state => ({
    axiosInstance: state.auth.get('axiosInstance'),
    selectedFault: state.faults.get('selectedFault'),
    drawingFault: state.faults.get('drawingFault'),
    message: state.faults.get('message'),
    faultTagsDictionary: state.faults.get('faultTagsDictionary')
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
    addFault,
    editFault,
    startDrawingFault,
    finishDrawingFault,
    cancelDrawingFault,
    setEditMode,
    clearMessage,
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps, null)(FlightCreator));


// WEBPACK FOOTER //
// ./src/containers/content/faultsManager/FaultCreator.jsx